// es.js
import elementLocale from 'element-ui/lib/locale/lang/en' // 用英文作基础

export default {
  ...elementLocale,
  menu: {
    home: 'Inicio',
    product: 'Productos',
    news: 'Noticias y Recursos',
    about: 'Sobre Nosotros',
    contact: 'Contacto'
  },
  common: {
    welcome: 'Bienvenido'
  }
}